// LIST
export const FETCH_VISITORS = "app/VISITOR/FETCH_VISITORS";
export const FETCH_VISITORS_SUCCESS = "app/VISITOR/FETCH_VISITORS_SUCCESS";
export const FETCH_VISITORS_FAILURE = "app/VISITOR/FETCH_VISITORS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/VISITOR/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/VISITOR/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/VISITOR/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_VISITOR = "app/VISITOR/ADD_VISITOR";
export const ADD_VISITOR_SUCCESS = "app/VISITOR/ADD_VISITOR_SUCCESS";
export const ADD_VISITOR_FAILURE = "app/VISITOR/ADD_VISITOR_FAILURE";

// EDIT
export const EDIT_VISITOR = "app/VISITOR/EDIT_VISITOR";
export const EDIT_VISITOR_SUCCESS = "app/VISITOR/EDIT_VISITOR_SUCCESS";
export const EDIT_VISITOR_FAILURE = "app/VISITOR/EDIT_VISITOR_FAILURE";

// DELETE
export const DELETE_VISITOR = "app/VISITOR/DELETE_VISITOR";
export const DELETE_VISITOR_SUCCESS = "app/VISITOR/DELETE_VISITOR_SUCCESS";
export const DELETE_VISITOR_FAILURE = "app/VISITOR/DELETE_VISITOR_FAILURE";

export const CLOCK_VISITOR = "app/VISITOR/CLOCK_VISITOR";
export const CLOCK_VISITOR_SUCCESS = "app/VISITOR/CLOCK_VISITOR_SUCCESS";
export const CLOCK_VISITOR_FAILURE = "app/VISITOR/CLOCK_VISITOR_FAILURE";

export const SEARCH_VISITOR = "app/VISITOR/SEARCH_VISITOR";
export const SEARCH_VISITOR_SUCCESS = "app/VISITOR/SEARCH_VISITOR_SUCCESS";
export const SEARCH_VISITOR_FAILURE = "app/VISITOR/SEARCH_VISITOR_FAILURE";

export const SEARCH_RESIDENT = "app/VISITOR/SEARCH_RESIDENT";
export const SEARCH_RESIDENT_SUCCESS = "app/VISITOR/SEARCH_RESIDENT_SUCCESS";
export const SEARCH_RESIDENT_FAILURE = "app/VISITOR/SEARCH_RESIDENT_FAILURE";

export const EXPORT_VISITORS = "app/VISITOR/EXPORT_VISITORS";
export const EXPORT_VISITORS_SUCCESS = "app/VISITOR/EXPORT_VISITORS_SUCCESS";
export const EXPORT_VISITORS_FAILURE = "app/VISITOR/EXPORT_VISITORS_FAILURE";

export const FETCH_ENTRIES = "app/VISITOR/FETCH_ENTRIES";
export const FETCH_ENTRIES_SUCCESS = "app/VISITOR/FETCH_ENTRIES_SUCCESS";
export const FETCH_ENTRIES_FAILURE = "app/VISITOR/FETCH_ENTRIES_FAILURE";

export const FIND_VISITOR = "app/VISITOR/FIND_VISITOR";
export const FIND_VISITOR_SUCCESS = "app/VISITOR/FIND_VISITOR_SUCCESS";
export const FIND_VISITOR_FAILURE = "app/VISITOR/FIND_VISITOR_FAILURE";
